<template>
	<section
		id="formBlock"
		class="px-content pt-[96px] pb-[120px] will-change"
		:data-scroll-section="inner == 'false'"
	>
		<div class="mb-12 text-center max-w-[588px] mx-auto">
			<h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">
				{{ blockData.title }}
			</h2>
			<p
				class="xl:max-w-[40vw]"
				v-show="blockData.text"
				v-html="blockData.text"
			></p>
		</div>
		<div class="form-wraper mt-12 xl:mt-16 max-w-[588px] mx-auto">
			<div
				v-show="blockData.form_shortcode"
				v-html="blockData.form_shortcode"
			></div>
		</div>
	</section>
</template>

<script>
export default {
	name: "FormBlock",
	data: function () {
		return {};
	},
	mounted() {
		window.addEventListener("load", () => {
			let radio = document.querySelectorAll(
				'.wpcf7-form-control-wrap.interest .wpcf7-list-item input[type="radio"]'
			);
			radio.forEach((el) => {
				el.onchange = (e) => {
					let conditionals = e.target
						.closest("form")
						.querySelectorAll(".conditional-fields");
					if (e.target.closest(".wpcf7-list-item").classList.contains("last")) {
						conditionals[0].style.display = "block";
					} else {
						conditionals[0].style.display = "none";
					}
				};

				if (
					el.closest(".wpcf7-list-item").classList.contains("last") &&
					el.getAttribute("checked") == "checked"
				) {
					el
						.closest("form")
						.querySelectorAll(".conditional-fields")[0].style.display = "block";
				} else {
					el
						.closest("form")
						.querySelectorAll(".conditional-fields")[0].style.display = "none";
				}
			});
		});

		setTimeout(() => {
			document.querySelectorAll(".wpcf7-countrytext")[0].readOnly = true;

			let country = document.querySelectorAll("li.country");
			let defaultCountry = document.querySelectorAll('input[name="country"]')[0]
				.value;
			country.forEach((el) => {
				el.addEventListener("click", (e) => {
					if (typeof el.dataset.dialCode === "undefined") {
						document.querySelectorAll('[name="country-code"]')[0].value =
							el.dataset.countryCode;
					}
				});
				if (typeof el.dataset.dialCode === "undefined") {
					if (
						defaultCountry == el.querySelectorAll(".country-name")[0].innerHTML
					) {
						document.querySelectorAll('[name="country-code"]')[0].value =
							el.dataset.countryCode;
					}
				}
			});

			document.querySelectorAll('[name="preferred_language"]')[0].value =
				this.currentLanguage;

			if (typeof this.fieldsData.number_of_bedrooms !== "undefined") {
				var size =
					parseInt(this.fieldsData.number_of_bedrooms) == -1
						? 2
						: parseInt(this.fieldsData.number_of_bedrooms) + 2;
				document.querySelectorAll('[name="unit_size"]')[0].value = size;
			}
		}, 1000);

		let wpcf7Elm = this.$el.querySelector(".wpcf7");
		wpcf7Elm.addEventListener(
			"wpcf7submit",
			(event) => {
				event.detail.apiResponse.invalid_fields.forEach((el) => {
					let parent = this.$el
						.querySelectorAll(el.into)[0]
						.closest(".form-control");
					parent.classList.add("invalid-input");
				});
			},
			false
		);
		this.$el.querySelectorAll("form")[0].addEventListener("submit", () => {
			this.$el.querySelectorAll(".form-control.invalid-input").forEach((el) => {
				el.classList.remove("invalid-input");
			});
		});

		setTimeout(() => {
			let countryList = document.getElementsByClassName("country-list");
			countryList.forEach((el) => {
				el.classList.add("scroll-just-this");
				el.addEventListener("mouseenter", (e) => {
					if (!el.classList.contains("hide")) {
						this.$root.scroll.stop();
					}
				});
				el.addEventListener("mouseleave", (e) => {
					this.$root.scroll.start();
				});
			});
		}, 1000);
	},
	methods: {},
};
</script>

<style scoped>
.scroll-just-this {
	overscroll-behavior: contain;
}
</style>
